import { render, staticRenderFns } from "./question-pagination-container.vue?vue&type=template&id=f8326ea0&"
import script from "./question-pagination-container.vue?vue&type=script&lang=js&"
export * from "./question-pagination-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports